<!-- Header Section -->
<header class="header">
  <div class="logo">Kiko VPN</div>
  <nav class="navigation">
      <a href="/home">Home</a>
      <a href="/downloads">Downloads</a>
      <a href="/privacy">Privacy</a>
      <a href="/terms">Terms</a>
      <a href="/reseller">Reseller</a>
      <a href="/faq">Faq</a>
      <a href="/support">Support</a>
      <a href="/about">About Us</a>
  </nav>
</header>
<div class="terms-container">
    <div class="terms-header">
      <h1>Terms of Service</h1>
    </div>
  
    <div class="terms-content">
      <h2>Introduction</h2>
      <p>Welcome to Kiko VPN! By using our service, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using our service.</p>
  
      <h2>Use of Service</h2>
      <p>Our VPN service is designed to protect your privacy and security online. By using our service, you agree not to:</p>
      <ul>
        <li>Use the service for illegal activities.</li>
        <li>Attempt to circumvent security measures or hack our service.</li>
        <li>Distribute malicious software or cause harm to others.</li>
      </ul>
  
      <h2>Account Registration</h2>
      <p>To access the features of our VPN service, you do not need any account registration.</p>
  
      <h2>Subscription and Payment</h2>
      <p>Our VPN service currently offers only one time payments. You agree to pay all applicable fees for the plan you choose. Payments are processed securely and in accordance with the payment method you provide. We reserve the right to change our subscription plans or pricing at any time.</p>
  
      <h2>Refund Policy</h2>
      <p>We offer a 14 Day Refund Policy with the following terms:</p>

      <h4>Eligibility for a Refund</h4>
      <ul>
        <li>You must request a refund within 14 days of your one-time payment.</li>
        <li>Refunds may not be granted if you have used an excessive amount of coupons or vpn usage hours</li>
        <li>Refunds apply only to first-time purchases. Repeat purchases are not eligible.</li>
        <li>If your account has been suspended or terminated due to a violation of our Terms of Service (e.g., illegal activity, abuse, or excessive simultaneous connections), you will not be eligible for a refund.</li>
        <li>Refunds will be processed within 7-10 business days and credited back to the original payment method.</li>
      </ul>

      <h4>How to Request a Refund</h4>
      <p>To request a refund, please contact our support team at <a href="mailto:kikovpnhelp@gmail.com">Support</a> with:</p>
      <ul>
        <li>Your order ID or transaction ID</li>
        <li>The email address used for the purchase</li>
        <li>A brief reason for your refund request (optional)</li>
        <li>Once we verify your request, we will process the refund and notify you via email.</li>
      </ul>

      <h4>Exceptions</h4>
      <ul>
        <li>Refunds are not available for purchases made through third-party platforms (e.g., App Store, Google Play). Please contact the respective store for their refund policy.</li>
        <li>Refunds for cryptocurrency or other non-reversible payment methods may not be available.</li>
      </ul>

      <h2>Termination</h2>
      <p>We reserve the right to suspend or terminate your account if you violate any of these terms. You can terminate your account at any time by contacting us or through the user interface on our website.</p>
  
      <h2>Liability Limitations</h2>
      <p>We make every effort to ensure the availability and reliability of our service. However, we are not liable for any damages, losses, or interruptions in service caused by technical issues, force majeure, or user misuse of the service.</p>
  
      <h2>Changes to Terms</h2>
      <p>We may update or modify these terms at any time. Any changes will be posted on this page, and the date of the last update will be indicated. By continuing to use the service, you accept the updated terms.</p>
  
      <h2>Contact Us</h2>
      <p>If you have any questions or concerns about our terms of service, please contact us at <a href="mailto:kikovpnhelp@gmail.com">Support</a>.</p>
    </div>
  </div>